import React, { useEffect, useState } from "react";
import { Row, Col, Button, Container, Card } from "react-bootstrap";
import { jwtDecode } from "jwt-decode";
import { getReminderPreferencesByPracticeNumbers } from "../../acommsapi";
import EmailModal from "./AddEditEmailComms"; // Import EmailModal directly, not AddEmail
import { getUserPracticeById } from "../../api";

export function EmailReminders({ refresh, onEmailUpdate = () => {} }) {
  const [emailData, setEmailData] = useState([]); // Array containing at most one entry
  const [selectedEmail, setSelectedEmail] = useState(null);
  const [modalShow, setModalShow] = useState(false);
  const [practices, setPractices] = useState([]); // Array of { practiceNumber, practiceName }

  // Fetch SMS preferences and user practices
  const loadEmailData = async () => {
    const token = sessionStorage.getItem("user");
    if (!token) return;
    const decoded = jwtDecode(token);
    const practiceNumbers = decoded.practice || [];

    // Load user practice objects for mapping numbers → names
    const userPractices = await getUserPracticeById(decoded._id);
    setPractices(userPractices);

    // Load SMS preferences
    const result = await getReminderPreferencesByPracticeNumbers(practiceNumbers, "Email");
    setEmailData(Array.isArray(result.data) ? result.data : []);
  };

  useEffect(() => {
    loadEmailData();
  }, [refresh]);

  const handleButtonClick = () => {
    if (emailData.length > 0) {
      setSelectedEmail(emailData[0]);
    } else {
      setSelectedEmail(null);
    }
    setModalShow(true);
  };

  // Helper: map array of practiceNumbers → array of practiceNames
  const mapToNames = (numbersArray) => {
    if (!Array.isArray(numbersArray)) return [];
    return numbersArray
      .map((num) => {
        const p = practices.find((pr) => pr.practiceNumber === num);
        return p ? p.practiceName : num;
      })
      .filter((name) => !!name);
  };

  // Helper: split names array into two roughly equal columns
  const splitInTwoCols = (names) => {
    const halfway = Math.ceil(names.length / 2);
    return [names.slice(0, halfway), names.slice(halfway)];
  };

  return (
    <Container fluid className="border-0">
          
      {emailData.length === 0 ? (
        <Card className="mb-4 border-0 shadow-sm">
          <Card.Body>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5 className="text-primary mb-0">Email Reminders</h5>
              <Button variant="primary" onClick={handleButtonClick}>
                Add Email Reminder
              </Button>
            </div>
            <p className="text-muted">No Email reminders configured.</p>
          </Card.Body>
        </Card>
      ) : (
        emailData.map((entry, idx) => {
          const oneDayNames = mapToNames(entry["1DayPracs"]);
          const sundayNames = mapToNames(entry["sundayPracs"]);
          const [oneDayCol1, oneDayCol2] = splitInTwoCols(oneDayNames);
          const [sundayCol1, sundayCol2] = splitInTwoCols(sundayNames);

          return (
            <Card key={idx} className="shadow-sm border-0 mb-4">
              <Card.Body>
                {/* Header with title + button */}
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <h5 className="text-primary mb-0">Email Reminders</h5>
                  <Button variant="primary" onClick={handleButtonClick}>
                    Edit Reminder
                  </Button>
                </div>

                {/* Two columns side by side with vertical divider */}
                <Row>
                  {/* 1 Day Before */}
                  <Col md={6}>
                    <h6 className="text-primary mb-3">1 Day Before</h6>
                    <Row>
                      <Col xs={6}>
                        {oneDayCol1.map((name, i) => (
                          <div key={i} className="mb-1">
                            {name}
                          </div>
                        ))}
                      </Col>
                      <Col xs={6}>
                        {oneDayCol2.map((name, i) => (
                          <div key={i} className="mb-1">
                            {name}
                          </div>
                        ))}
                      </Col>
                    </Row>
                  </Col>

                  {/* Divider Line */}
                  <Col
                    md={6}
                    className="border-start ps-4"
                  >
                    <h6 className="text-primary mb-3">On Sunday for the Week</h6>
                    <Row>
                      <Col xs={6}>
                        {sundayCol1.map((name, i) => (
                          <div key={i} className="mb-1">
                            {name}
                          </div>
                        ))}
                      </Col>
                      <Col xs={6}>
                        {sundayCol2.map((name, i) => (
                          <div key={i} className="mb-1">
                            {name}
                          </div>
                        ))}
                      </Col>
                    </Row>
                  </Col>
                </Row>

                {/* Messages in one row, side by side */}
                <Row className="mt-4">
                  <Col md={6}>
  <strong>Email:</strong>
  <div
    className="border p-3 rounded bg-light mt-1"
    dangerouslySetInnerHTML={{ __html: entry["1DayText"] || "—" }}
  />
</Col>
<Col md={6}>
  <strong>Email:</strong>
  <div
    className="border p-3 rounded bg-light mt-1"
    dangerouslySetInnerHTML={{ __html: entry["sundayText"] || "—" }}
  />
</Col>

                </Row>
              </Card.Body>
            </Card>
          );
        })
      )}

      {/* Use SmsModal directly instead of AddSms */}
      <EmailModal
  show={modalShow}
  onHide={() => setModalShow(false)}
  emailDetail={selectedEmail}    
  onSmsUpdate={() => {
    setModalShow(false);
    setSelectedEmail(null);
    loadEmailData();
    onEmailUpdate();
  }}
/>

    </Container>
  );
}